export const DEFAULT_FONT_FAMILY = 'Helvetica, Arial, sans-serif';
export const WEB_FONTS = 'Web Fonts';
export const SYSTEM_FONTS = 'System Fonts';